<template>
  <div v-if="showBar && (aStore.config && !aStore.config.cordova)" class="fixed bottom-0 inset-x-0 z-60 bg-white">
    <div class="p-4 flex flex-col md:flex-row items-center justify-between bg-primary/30 text-black shadow-x">
      <div class="mb-2 md:mb-0 text-center md:text-left">
        Per migliorare l'esperienza dell'utente, questo sito utilizza cookie tecnici e di terze parti.
        Proseguendo nella navigazione, acconsenti all’uso dei
        <a href="http://www.xmenu.it/it/cookies" target="_blank"
          class="underline text-primary/80 hover:text-primary font-semibold">cookie</a>.
      </div>
      <div class="flex space-x-2">
        <button @click.prevent="acceptCookies"
          class="px-4 py-2 bg-primary/80 text-white hover:bg-primary rounded flex items-center justify-center">
          Ok
        </button>
        <button @click.prevent="acceptCookies" class="text-2xl leading-none" aria-label="Chiudi">
          <PhX weight="duotone" class="h-6 w-6" />
        </button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue';
import { useStoreApp } from '@/stores/app';
import { useStoreRestaurant } from '@/stores/restaurant';
import { PhX } from '@phosphor-icons/vue';

// Nome e durata (in giorni) del cookie
const COOKIE_NAME = 'cookieAccepted';
const COOKIE_EXPIRE_DAYS = 365;
const aStore = useStoreApp();
const rStore = useStoreRestaurant();

// Prop per posizionare la barra in 'bottom' o 'top'
const { position } = defineProps({
  position: {
    type: String,
    default: 'bottom', // oppure 'top'
    validator: v => ['bottom', 'top'].includes(v)
  }
})

const showBar = ref(false)

// Genera le classi per posizionamento
const barClasses = computed(() => {
  return position.value === 'top'
    ? 'top-0 translate-y-0'
    : 'bottom-0 translate-y-full'
})

function setCookie(name, value, days) {
  const d = new Date()
  d.setTime(d.getTime() + days * 24 * 60 * 60 * 1000)
  document.cookie = `${name}=${value};expires=${d.toUTCString()};path=/`
}

function getCookie(name) {
  const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'))
  return match ? match[2] : null;
}

function acceptCookies() {
  setCookie(COOKIE_NAME, 'true', COOKIE_EXPIRE_DAYS)
  showBar.value = false;
}

onMounted(() => {
  if (!getCookie(COOKIE_NAME)) {
    showBar.value = true;
  }
})
</script>
